// RadioButton.js

import React, { useState } from "react";

import '../../styles/buttons/RadioButton.css';
import TextField from "../text/TextField";

const RadioButton = ({state, text}) => {

    const [agreed, setAgreed] = useState(state);

    return (
        <>
            <div className='radioButton-container'>
                
                <input className="radioButton-button" 
                    type="checkbox"
                    checked={agreed}
                    onChange={(e) => setAgreed(e.target.checked)}
                />

                <TextField 
                    text={text}
                    bold={false}
                    fontSize='0.875rem'
                    fontColor="#000000"
                
                />

            
            </div> 
        
        </>
    )
}

export default RadioButton;